var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWeek = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 17",
    style: {
      enableBackground: "new 0 0 16 17"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0E3F6C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.7,15.2H3.3c-1.1,0-2.1-0.9-2.1-2V4.8c0-1.1,0.9-1.9,2.1-1.9h1.2V2.4c0-0.4,0.3-0.8,0.8-0.8S6.1,2,6.1,2.4 v0.5h3.8V2.4c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v0.5h1.2c1.1,0,2.1,0.9,2.1,1.9v8.4C14.8,14.3,13.8,15.2,12.7,15.2z M2.8,8v5.2 c0,0.2,0.3,0.5,0.6,0.5h9.3c0.3,0,0.6-0.2,0.6-0.5V8H2.8z M2.8,6.5h10.5V4.8c0-0.2-0.3-0.4-0.6-0.4h-1.2v0.4c0,0.4-0.3,0.8-0.8,0.8 S9.9,5.2,9.9,4.8V4.4H6.1v0.4c0,0.4-0.3,0.8-0.8,0.8S4.6,5.2,4.6,4.8V4.4H3.3C3,4.4,2.8,4.6,2.8,4.8V6.5z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWeek, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/week.a62538d3.svg";
export { ForwardRef as ReactComponent };